"use strict";

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OptionCollection = exports.OptionCollection = function () {
  function OptionCollection(options) {
    _classCallCheck(this, OptionCollection);

    this.options = options;
  }

  OptionCollection.prototype.allOptions = function allOptions() {
    return this.options;
  };

  OptionCollection.prototype.findOptionByValue = function findOptionByValue(value) {
    return this.options.find(function (option) {
      return option.props.value === value;
    });
  };

  OptionCollection.prototype.findOptionByKey = function findOptionByKey(key) {
    return this.options.find(function (option) {
      return option.key === key;
    });
  };

  OptionCollection.prototype.getNextEnabledKey = function getNextEnabledKey(key) {
    var currentIndex = this.options.findIndex(function (option) {
      return option.key === key;
    });
    var lastIndex = this.options.length - 1;
    var next = void 0;
    if (currentIndex === -1) {
      next = this.options[0];
    } else if (currentIndex === lastIndex) {
      next = this.options[currentIndex];
    } else {
      next = this.options[currentIndex + 1];
    }

    if (next.props.disabled && currentIndex !== lastIndex) {
      return this.getNextEnabledKey(next.key);
    }
    return next.key;
  };

  OptionCollection.prototype.getPreviousEnabledKey = function getPreviousEnabledKey(key) {
    var currentIndex = this.options.findIndex(function (option) {
      return option.key === key;
    });
    var previous = void 0;
    if (currentIndex === 0) {
      previous = this.options[0];
    } else {
      previous = this.options[currentIndex - 1];
    }

    if (currentIndex !== 0 && previous.props.disabled) {
      return this.getPreviousEnabledKey(previous.key);
    }
    return previous.key;
  };

  return OptionCollection;
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-a11y-select/lib/lib/optionCollection.js
// module id = 1673
// module chunks = 14